export const PREVIEW_IMAGE_WIDTHS = [480, 960, 1024, 2048];
export const PREVIEW_VIDEO_WIDTHS = [480 /* , 960 */];
export const FULL_VIDEO_HEIGHTS_POW2 = [512 /* , 1024, 2048 */];
export const FULL_VIDEO_HEIGHTS_DEFAULT = [720 /* , 1080, 1440, 2160 */];

export const FFMPEG_QUALITY_LEVEL = 4;

export const PREVIEW_VIDEO_MAX_DURATION = 20;

export const PREVIEW_IMAGE_FILENAME_PREFIX = 'preview_image_';
export const PREVIEW_VIDEO_FILENAME_PREFIX = 'preview_video_';
export const PREVIEW_VIDEO_SUBTITLES_PREFIX = 'subtitles_';
export const ORIGINAL_FILENAME_PREFIX = 'original_';
export const FULL_VIDEO_FILENAME_PREFIX = 'full_video_';

// uses ffmpeg or cloudinary
export const FFMEPEG_WASM_ENABLED = true;
